import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: 'history',

	base: process.env.BASE_URL,

	routes: [{
		path: '/rv-quiz',
		name: 'RVQuiz',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "RVQuiz" */ '@/views/RVQuiz'),
	}, {
		path: '/rvready-thankyou',
		name: 'RVReady PostEntry',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "RVReadyPostEntry" */ '@/views/RVReady/PostEntry'),
	}, {
		path: '/rvready-resources',
		name: 'RVReady Resources',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "RVReadyResources" */ '@/views/RVReady/Resources'),
	}, {
		path: '/rvready',
		name: 'RVReady',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "RVReady" */ '@/views/RVReady'),
	}, {
		path: '/racing',
		name: 'Racing',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Racing" */ '@/views/Racing'),
	}, {
		path: '/tailgating',
		name: 'Tailgating',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Tailgating" */ '@/views/Tailgating'),
	}, {
		path: '/trucking',
		name: 'Trucking',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Trucking" */ '@/views/Trucking'),
	}, {
		path: '/rvlifestyle',
		name: 'RVLifestyle',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			coupon: 'RVLIFESTYLE',
			logo: require('@/assets/influencer/rvlifestyle/logo.png'),
			name: 'RV Lifestyle',
		},
	}, {
		path: '/outdoorsy',
		name: 'Outdoorsy',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			amount: '40',
			coupon: 'OUTDOORSY',
			logo: require('@/assets/influencer/outdoorsy/logo.svg'),
			name: 'Outdoorsy',
			tfn: 'temporary',
		},
	}, {
		path: '/wanderpreneurs',
		name: 'Wanderpreneurs',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			coupon: 'WANDER',
			logo: require('@/assets/influencer/wanderpreneurs/logo.png'),
			name: 'Wanderpreneurs',
		},
	}, {
		path: '/nomadic',
		name: 'Nomadic',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			coupon: 'NOMADIC',
			logo: require('@/assets/influencer/nomadic/logo.png'),
			name: 'Nomadic Fanatic',
		},
	}, {
		path: '/rvmiles',
		name: 'RVMiles',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			coupon: 'RVMILES',
			logo: require('@/assets/influencer/rvmiles/logo.png'),
			name: 'RV Miles',
		},
	}, {
		path: '/oob',
		name: 'OutsideOurBubble',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			coupon: 'OOB',
			logo: require('@/assets/influencer/oob/logo.png'),
			name: 'Outside Our Bubble',
		},
	}, {
		path: '/rvshare',
		name: 'RVshare',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			coupon: 'RVSHARE',
			logo: require('@/assets/influencer/rvshare/White-Logo.png'),
			name: 'RVshare',
		},
	}, {
		path: '/koa',
		name: 'KOA',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "Influencer" */ '@/views/Influencer'),
		props: {
			coupon: 'KOA',
			logo: require('@/assets/influencer/koa/logo.png'),
			name: 'Kampground of America',
		},
	}, {
		path: '/',
		name: 'HomePage',
		meta: {
			title: 'DISH Outdoor TV | DISHForMyRV.com',
		},
		component: () => import( /* webpackChunkName: "HomePage" */ '@/views/HomePage'),
	}, {
		path: '/*',
		redirect: '/',
	}],
})

router.afterEach(to => {
	const _hsq = window._hsq = window._hsq || []
	_hsq.push(['setPath', to.fullPath])
	_hsq.push(['trackPageView'])
})

export default router
